import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {

    creditNoteList:[],
    creditNote:{},
}


const creditNote = {
    namespaced : true,
    state,
    mutations,
    actions,
    getters
}

export default creditNote;